/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    const module = this;

    const Settings = {
        tabsDose: {
            slidesPerView: "auto",
            simulateTouch: false,
            centeredSlides: true,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            allowTouchMove: false,
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }

                    const toggler = document.querySelector(".js-slider-toggle");
                    const prevBtns = toggler && document.querySelectorAll(".js-tab-name--prev");
                    const nextBtns = toggler && document.querySelectorAll(".js-tab-name--next");
                    const toggleButtons = document.querySelectorAll(".js-toggle-buttons");

                    const sliderPack = document.querySelector("[data-slider-settings='tabsPack']");

                    if (sliderPack) {
                        sliderPack.classList.add("js-visible");
                        let sliderSettingsKey = sliderPack.getAttribute("data-slider-settings"); // получаем data-атрибут
                        const sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

                        if (sliderSettingsKey && sliderSettingsObject) {
                            new itsoftApp.modules.slidersLibrary.callback(sliderPack, sliderSettingsObject);
                        } else {
                            new itsoftApp.modules.slidersLibrary.callback(sliderPack);
                        }
                    }

                    if (nextBtns[0].classList.contains("js-tab-name--active")) {
                        swiper.slideNext();
                    }

                    Array.prototype.forEach.call(prevBtns, function (prevBtn) {
                        prevBtn.addEventListener("click", function () {
                            // if (!prevBtn.classList.contains("js-tab-name--active")) {
                                Array.prototype.forEach.call(nextBtns, function (nextBtn) {
                                    nextBtn.classList.remove("js-tab-name--active");
                                });

                                Array.prototype.forEach.call(prevBtns, function (prevBtn) {
                                    prevBtn.classList.add("js-tab-name--active");
                                });

                                swiper.slidePrev();
                                Swiper.initedSliders["tabsPack"].slidePrev();
                                // toggler.classList.toggle('js-toggle--active');
                                // toggleButtons[0] && toggleButtons[0].classList.add("js-toggle-buttons--active");
                                // toggleButtons[1] && toggleButtons[1].classList.remove("js-toggle-buttons--active");
                            // }
                        });
                    })

                    Array.prototype.forEach.call(nextBtns, function (nextBtn) {
                        nextBtn.addEventListener("click", function () {
                            // if (!nextBtn.classList.contains("js-tab-name--active")) {
                                Array.prototype.forEach.call(prevBtns, function (prevBtn) {
                                    prevBtn.classList.remove("js-tab-name--active");
                                })

                                Array.prototype.forEach.call(nextBtns, function (nextBtn) {
                                    nextBtn.classList.add("js-tab-name--active");
                                });
                                swiper.slideNext();
                                Swiper.initedSliders["tabsPack"].slideNext();
                                // toggler.classList.toggle('js-toggle--active');
                                // toggleButtons[1] && toggleButtons[1].classList.add("js-toggle-buttons--active");
                                // toggleButtons[0] && toggleButtons[0].classList.remove("js-toggle-buttons--active");
                            // }
                        });
                    })
                }
            }
        },

        tabsPack: {
            slidesPerView: "auto",
            simulateTouch: false,
            centeredSlides: true,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            allowTouchMove: false,
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }

                    const toggler = document.querySelector(".js-slider-toggle");
                    const nextBtns = toggler && document.querySelectorAll(".js-tab-name--next");

                    if (nextBtns[0].classList.contains("js-tab-name--active")) {
                        swiper.slideNext();
                    }

                }
            }
        }
    }

    const getSettings = function (slidersSettingsKey) {
        return Settings[slidersSettingsKey];
    }

    module.getSettings = getSettings;
});